<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <loadingcomp
      ref="loadingcomp"
      v-bind:mesaj="loadingmesaj"
      v-model="loadingdialog"
    ></loadingcomp>
    <doviz ref="doviz" @setCurrencyValue="setCurrency($event)"></doviz>

    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card flat light>
          <v-layout row wrap>
            <v-flex xs12 sm12 md5 pa-3>
              <v-card pa-2 style="min-height: 220px">
                <v-layout row wrap align-center pl-3 pb-4>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Satış Grubu"
                      v-model="val.TakipNo"
                    ></v-text-field>
                    <tarihim
                      :etiket="$t('Payment-Date')"
                      :detaygizle="false"
                      v-model="val.OdemeTarihi"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field :label="$t('Exchange-Rate-v2')" v-model="val.Kur"></v-text-field>
                    <v-select
                      dense
                      :items="doviztipi"
                      item-text="Title"
                      item-value="DovizKod"
                      :label="$t('Currency-Unit')"
                      v-model="val.ParaBirimi"
                      @change="getCurrencyValue()"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md6 v-if="!odemeTipShow">
                    <cariaracomp
                      v-bind:etiket="$t('Select-Counter-Current')"
                      :rules="false"
                      v-bind:value="val.NakitBilgi.KarsiCari"
                      v-model="val.NakitBilgi.KarsiCari"
                    ></cariaracomp>
                  </v-flex>
                  <v-flex xs12 sm12 md6 v-if="!odemeTipShow">
                    <v-text-field
                      hide-details=""
                      label="Karşı Cari Açk."
                      v-model="val.NakitBilgi.KarsiCariAciklama"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 v-if="odemeTipShow">
                    <v-text-field
                      :label="$t('Transfer-Bank')"
                      v-model="val.HavaleBilgi.Banka"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 v-if="odemeTipShow">
                    <v-text-field
                      :label="$t('Transfer-Explanation')"
                      v-model="val.HavaleBilgi.Aciklama"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex xs12 sm12 md2 pa-3>
              <v-card pa-2 style="min-height: 220px">
                <v-layout row wrap align-center pl-3>
                  <v-radio-group
                    hide-details=""
                    :mandatory="false"
                    v-model="val.OdemeTipi"
                    @change="odemeTipiChange(val.OdemeTipi)"
                  >
                    <template v-slot:label>
                      <span class="title"> {{ $t("Payment-Type") }} </span>
                    </template>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap="">
                        <v-flex
                          v-for="(item, index) in itemsOdemeTip"
                          v-bind:key="index"
                          xs12
                          pa-2
                          sm12
                          md12
                        >
                          <v-radio :label="item.text" v-bind:value="item.value">
                          </v-radio>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-radio-group>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex xs12 sm12 md5 pa-3>
              <v-card style="min-height: 220px">
                <v-layout row wrap align-center pl-3>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :disabled="odemeKartShow"
                      :label="$t('Card-No')"
                      v-model="val.KrediKartBilgi.KartNo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-autocomplete
                      :items="bankapositems"
                      :disabled="odemeKartShow"
                      @change="taksitgetirservis(val.KrediKartBilgi.Banka)"
                      v-model="val.KrediKartBilgi.Banka"
                      item-text="Title"
                      item-value="PosKodu"
                      clearable
                      :label="$t('Bank')"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md6>
                        <v-select
                          dense
                          :items="itemsKartTipi"
                          :disabled="odemeKartShow"
                          item-text="text"
                          item-value="value"
                          v-model="val.KrediKartBilgi.KartTipi"
                          label="Tip"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-select
                          :disabled="odemeKartShow"
                          :items="taksitsayiservis"
                          v-model="val.KrediKartBilgi.Taksit"
                          item-text="TaksitAciklama"
                          item-value="TaksitAdet"
                          clearable
                          :label="$t('Instalment')"
                        >
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <v-flex pa-3 xs12 sm12 md12>
          <v-card width="100%" class="elevation-1 pa-1">
            <v-layout row wrap align-center justify-end>
              <v-flex xs12 sm6 md2>
                <v-btn
                  color="blue-grey"
                  @click="odemeyiAl()"
                  class="white--text"
                >
                  Ödemeyi Al
                  <v-icon right dark>add_shopping_cart</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm6 md2> </v-flex>
              <v-flex xs12 sm12 md2>
                <span class="font-weight-large title" style="color: #67768f">
                  {{ $t("Grand-Total") }} :</span
                >
              </v-flex>
              <v-layout row align-center justify-space-around>
                <v-flex xs12 sm6 md2>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text body-1"
                    ><span style="color: #67768f">{{ $t('Amount') }} {{ kurTipi }} :</span>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text body-1"
                  >
                    {{ moneyformat(topTutarToplam) }} 
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text body-1"
                    ><span style="color: #67768f"> {{ $t('Paid') }} {{ kurTipi }} :</span>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text body-1"
                  >
                    {{ moneyformat(topOdenenToplam) }} 
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text body-1"
                    ><span style="color: #67768f">{{ $t('Remaining') }} {{ kurTipi }} :</span>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text body-1"
                  >
                    {{ moneyformat(topKalanToplam) }} 
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-flex xs12 sm12 md12>
                    <parainput
                      :etiket="$t('Payment-Amount')"
                      aktif="'true'"
                      :autocomplete="'autocomplete'"
                      v-model="topOdenecekToplam"
                      :simge="kurTipi"
                    >
                    </parainput>
                  </v-flex>
                </v-flex>

                
              <!-- <v-flex xs12 sm6 md1>
                  <v-btn
                    icon
                    small
                    slot="activator"
                    flat
                    @click="taksimodemeDialogOpen(val.PNR_No)"
                  >
                    <v-icon color="info" medium git>add_box</v-icon>
                  </v-btn>
              </v-flex> -->

              </v-layout>
            </v-layout>
          </v-card>
        </v-flex>
      </v-flex>

      <v-flex
        xs12
        sm12
        md12
        v-for="(itemTahsilat, index) in tahsilatList"
        :key="index"
      >
        <odemebilgileri
          :getData="getDataStatus"
          :getDataTaksim="getDataTaksim"
          v-bind:value="itemTahsilat"
          :paraBirimi="kurTipi"
          :kurDegeri="val.Kur"
          @odenecekTutarHesapla="odenecekHesapla($event)"
          @odenecekTutarSifirla="odenecekSifirla()"
          @odemeHazirla="odemeHazirla($event)"
          @getodenecekler="VizeTahsilatLoad()"
          @odemeHazirlaTaksim="odemeHazirlaTaksim($event)"
        ></odemebilgileri>
      </v-flex>

      <v-layout row justify-center>
        <v-dialog v-model="taksimDialog" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Otomatik Ödeme Al</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field label="Toplam Ödeme Tutarı" v-model="taksimTutar" required></v-text-field>
                  </v-flex>
              
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="taksimDialog = false">Kapat</v-btn>
              <v-btn color="blue darken-1" flat @click="odemeyiTaksimAl()">Ödemeyi Al</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import auth from "../../../../../api/auth";
import tool from "../../../coper/tools";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import odemebilgileri from "@/components/app/coper/vize/comp/odemebilgileri";
import helpers from "@/components/app/customcomp/helpers.js";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import parainput from "@/components/app/customcomp/parainput.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import doviz from "@/components/app/muhasebe/comp/doviz.vue";

export default {
  props: ["value", "takipNo"],
  components: {
    tarihim,
    odemebilgileri,
    cariaracomp,
    parainput,
    loadingcomp,
    snackbarcomp,
    doviz,
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      loadingmesaj: "Vize",
      loadingdialog: false,
      text1: "",
      snackbar: false,
      getDataStatus: 0,
      getDataTaksim:0,
      odemeTipShow: false,
      odemeKartShow: true,
      bankapositems: [],
      taksitsayiservis: [],
      servistaksitsayi: "",
      itemsKartTipi: [
        {
          text: "VISA",
          value: 0,
        },
        {
          text: "MASTER",
          value: 1,
        },
        {
          text: "AmEx",
          value: 2,
        },
      ],
      kurTipi: "",
      topTutarToplam: 0,
      topOdenenToplam: 0,
      topKalanToplam: 0,
      topOdenecekToplam: 0,
      doviztipi: [],
      kurList: [],
      kayitTarihi: null,
      tahsilatList: [],
      itemsOdemeTip: [
        {
          text: "Nakit",
          value: 0,
        },
        {
          text: this.$t('Credit-Card'),
          value: 1,
        },
        {
          text: this.$t('Transfer-v3'),
          value: 2,
        },
        {
          text: "Sanal Pos",
          value: 3,
        },
      ],
      controlSave:0,
      taksimDialog:false,
      taksimPnr:0,
      taksimTutar:0
    };
  },
  methods: {
    taksimodemeDialogOpen(val){
      this.taksimDialog = true;
      this.taksimPnr = val;
    },
    getCurrencyValue() {
      this.$refs.doviz.getCurrencyValue(this.val.ParaBirimi);
      this.VizeTahsilatLoad();
      this.kurTipi = this.val.ParaBirimi;
    },
    setCurrency(val) {
      this.val.Kur = val;
    },
    odemeHazirlaTaksim(value){
      var pnrList = [];
      this.tahsilatList.forEach(element => {
        let pnrItem ={
          PNR_No:element.PNR_No,
          Tutar:element.Tutar
        };
        pnrList.push(pnrItem);
      });
      
     
      this.controlSave++;
      
      
      //this.val.PnrTutarListesi.push(value);

      
      if (this.controlSave == this.tahsilatList.length) {
        this.val.PnrTutarListesi = pnrList;
        let params = {
          ...this.val,
          Tutar:this.taksimTutar
        }

        tool.http_post(this, "VizeTahsilatTaksim", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.VizeTahsilatLoad();
              this.getDataTaksim = 0;
              this.val.PnrTutarListesi.length = 0;
              this.loadingdialog = false;
              this.taksimDialog =false;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.getDataTaksim = 0;
              this.val.PnrTutarListesi.length = 0;
              this.loadingdialog = false;
              this.taksimDialog =false;
            }
          },
          (response) => {
            this.text1 = "Hata Oluştu, tekrar deneyiniz";
            this.snackbar = true;
            this.taksimDialog =false;
            this.getDataTaksim = 0;
            this.val.PnrTutarListesi.length = 0;
            this.loadingdialog = false;
          }
        );
      }
    },
    odemeHazirla(value) {
      this.controlSave++;
      if(value.Tutar != 0){
        this.val.PnrTutarListesi.push(value);
      }

      if (this.controlSave == this.tahsilatList.length) {
        tool.http_post(this, "VizeTahsilatEkle", this.val).then(
          (response) => {
            if (response.body.Status == true) {
              this.VizeTahsilatLoad();
              this.getDataStatus = 0;
              this.val.PnrTutarListesi.length = 0;
              this.loadingdialog = false;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.getDataStatus = 0;
              this.val.PnrTutarListesi.length = 0;
              this.loadingdialog = false;
            }
          },
          (response) => {
            this.text1 = "Hata Oluştu, tekrar deneyiniz";
            this.snackbar = true;
            this.getDataStatus = 0;
            this.val.PnrTutarListesi.length = 0;
            this.loadingdialog = false;
          }
        );
      }
    },
    odemeyiTaksimAl(){
      this.loadingdialog = true;
      this.loadingmesaj = this.$t("Collection");
      this.getDataTaksim += 1;
    },
    odemeyiAl() {
      this.loadingdialog = true;
      this.loadingmesaj = this.$t("Collection");
      this.getDataStatus += 1;
    },
    odenecekSifirla() {
      this.topOdenecekToplam = 0;
    },
    odenecekHesapla(val) {
      this.topOdenecekToplam += parseInt(val);
    },
    VizeTahsilatLoad() {
      this.loadingdialog = true;
      this.topTutarToplam = 0;
      this.topOdenenToplam = 0;
      this.topKalanToplam = 0;
      this.controlSave = 0;
      let params = {
        TakipNo: this.takipNo,
        ParaBirimi: this.val.ParaBirimi,
      };
      tool.http_post(this, "VizeTahsilatLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.tahsilatList = response.body.data;
            response.body.data.forEach((element) => {
                this.topTutarToplam += element.Tutar;
                this.topOdenenToplam += element.Odenen;
                this.topKalanToplam += element.Kalan;
            });
            this.loadingdialog = false;
            //Tutarları toplayalım
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingdialog = false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingdialog = false;
        }
      );
    },
    calculateCurrency(amount, toValue, fromValue) {
      var result = 0;
      result = (amount * toValue) / fromValue;

      return result;
    },
    getKur() {
      if (this.kurList.length == 0) {
        if (this.kayitTarihi == null) {
          this.kayitTarihi = tool.Now_yyyy_MM_dd();
        }
        tool
          .http_post(this, "KurAra", {
            tarih: this.kayitTarihi,
          })
          .then(
            (response) => {
              this.kurList = response.body;
              this.selectKur(this.kurTipi);
            },
            (response) => {
              this.val.Kur = 1;
            }
          );
      } else {
        this.selectKur(this.kurTipi);
      }
    },
    selectKur(val) {
      var newVal = this.kurList.find(this.paraAraNew);
      var oldVal = this.kurList.find(this.paraAraOld);

      if (newVal == undefined) {
        this.val.Kur = 1;
        newVal = {
          kur: 1,
        };
      } else {
        this.val.Kur = newVal.kur;
      }

      if (oldVal == undefined) {
        oldVal = {
          kur: 1,
        };
      }

      if (oldVal.kur != newVal.kur) {
        this.topKalanToplam = this.calculateCurrency(
          this.topKalanToplam,
          oldVal.kur,
          newVal.kur
        );
        this.topOdenenToplam = this.calculateCurrency(
          this.topOdenenToplam,
          oldVal.kur,
          newVal.kur
        );
        this.topTutarToplam = this.calculateCurrency(
          this.topTutarToplam,
          oldVal.kur,
          newVal.kur
        );
      }
      this.kurTipi = this.val.ParaBirimi;
    },
    paraAraNew(paraBirimi) {
      return paraBirimi.paraBirimi == this.val.ParaBirimi;
    },
    paraAraOld(paraBirimi) {
      return paraBirimi.paraBirimi == this.kurTipi;
    },
    taksitgetirservis(v) {
      var tumliste = [];
      tumliste = this.bankapositems;

      tumliste.forEach((element) => {
        if (element.PosKodu == v) {
          this.taksitsayiservis = [];
          this.taksitsayiservis = element.Taksitler;
        }
        this.val.KrediKartBilgi.Taksit = parseInt(this.servistaksitsayi);
      });
    },
    odemeTipiChange(val) {
      if (val == 2) {
        this.odemeKartShow = true;
        this.odemeTipShow = true;
        this.val.HavaleBilgi.Aciklama = null;
        this.val.HavaleBilgi.Banka = null;
      } else {
        if (val == 0) {
          this.odemeKartShow = true;
        } else {
          this.odemeKartShow = false;
          this.val.NakitBilgi.KarsiCari = null;
          this.val.NakitBilgi.KarsiCariAciklama = null;
          this.odemeTipShow = false;
        }
      }
      this.val.KrediKartBilgi.KartNo = null;
      this.val.KrediKartBilgi.KartTipi = null;
      this.val.KrediKartBilgi.KartAdi = null;
      this.val.KrediKartBilgi.Banka = null;
      this.val.KrediKartBilgi.Taksit = null;
      this.val.KrediKartBilgi.PosKodu = null;
      this.val.KrediKartBilgi.PosTaksit = null;
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
  },
  filters: {
    gettime: function (t) {
      return helpers.getTime(t);
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
  },
  mounted() {
    this.VizeTahsilatLoad();
    this.kurTipi = "TL";
    this.val.TakipNo = this.takipNo;
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    var params = {
      CompanyCode: credentials.SirketKodu,
    };

    this.$http
      .post(auth.API_URL + "api/currency/List", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          this.doviztipi = response.body;
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-Döviz";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable-Döviz";
            this.snackbar = true;
          }
        }
      );

    this.$http
      .post(auth.API_URL + "api/BankPos/List", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          this.bankapositems = response.body;
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-bankpos";
            this.progress = false;
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable-bankpos";
            this.snackbar = true;
            this.progress = false;
          }
        }
      );
  },
};
</script>

<style>
</style>